<template>
    <div class="confirmation">
        <div class="container">
            <div class="position-relative">
                <h1 v-text="`Confirmation for Order #${order.id}`">Order Confirmation</h1>
                <div class="leading d-print-none">
                    <button class="btn btn-primary" @click="print">Print Invoice</button>
                </div>
            </div>

            <div v-if="flashSuccess" class="alert alert-success d-print-none">{{ flashSuccess }}</div>

            <p class="lead">

                Hello {{ user.name }}. Your order for <strong v-text="orderSize"></strong> gallons of oil will be charged to your credit card.

                <template v-if="orderSize > 150">
                    If your actual delivery is less than {{ orderSize }} gallons, any balance remaining will be refunded after the delivery has been made.
                </template>
            </p>
            <p>
                Your order will be delivered on or before <strong>{{ deliveryDate }}</strong>.
            </p>

            <receipt :allow-changes="false"></receipt>

        </div>
    </div>
</template>
<script>
import Receipt from './Receipt';
import moment from 'moment';
import numeral from 'numeral';

export default {
    components: {Receipt},

    data() {
        return {
            flashSuccess: '',
        }
    },

    methods: {
        print() {
            return window.print();
        },
        storageChecks() {
            if (localStorage.getItem('confirmationLoaded') == 1 || sessionStorage.getItem('confirmationLoaded') == 1) {
                this.$router.push({name: 'form'});
                return
            }
        },
        storageSets() {
            localStorage.setItem('confirmationLoaded', 1);
            sessionStorage.setItem('confirmationLoaded', 1);
        }
    },

    computed: {
        orderSize() {
            if (this.order.fill_tank && this.order.tank_size) {
                return this.order.tank_size;
            }
            if (this.order.gallons) {
                return this.order.gallons;
            }
            return this.order.tank_size;
        },

        gallonPrice() {
            return this.zone ? numeral(this.zone.price).format('0.000') : 0;
        },

        deliveryDate() {
            return moment(this.estimate['delivery_date']).format('dddd, MMMM Do');
        },

        order() {
            return this.$root.order;
        },

        zipCode() {
            return this.$root.zipCode;
        },

        zone() {
            return this.zipCode && this.zipCode.zone;
        },

        user() {
            return this.$root.user;
        },

        estimate() {
            return this.$root.estimate;
        },

        estimatedPrice() {
            return this.$root.estimate['total'];
        },
    },

    mounted() {
        this.storageChecks();

        if (!this.zipcode) {
            if (this.order.zip_code) {
                axios.get('/order/api/search', {params: {zip_code: this.order.zip_code}})
                    .then(response => {
                        this.$root.zipCode  = response.data.data;
                        this.$root.zip_code = this.$root.zipCode.zip_code;
                    })
                    .catch(response => {
                        this.$router.push({name: 'form'});
                    });
            } else {
                this.$router.push({name: 'form'});
                return
            }
        }
        this.storageSets();
    },

    created() {
        this.flashSuccess = this.$root.getFlashMessage('success', true);

        if (this.order.zip_code === null) {
            this.$router.push({name: 'form'});
        }
    },
};
</script>
